import { Component, OnInit } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  pdfSrc = 'assets/files/CDLT_FAQ_1.pdf';
  pdf: PDFDocumentProxy;

  constructor() { }

  ngOnInit(): void { }

}
